import { render, staticRenderFns } from "./baseSubAnalysis.vue?vue&type=template&id=673bdb6d&"
import script from "./baseSubAnalysis.vue?vue&type=script&lang=js&"
export * from "./baseSubAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports